import React from "react"
// import { graphql, useStaticQuery } from "gatsby"
// import BackgroundImage from "gatsby-background-image"
// import Image from "gatsby-image"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Sublinks from "../components/sublinks"
import Infolinia from "../components/infolinia"

import cennikStyles from "../components/Modals/ModalCennik.module.scss"
import Min60 from "../images/min60.png"
import Min600 from "../images/min600.png"

import '../sass/main.scss'

// const query = graphql`
//   {
//     fotka1: file(relativePath: { eq: "900x250-vitay-en.jpg" }) {
//       childImageSharp {
//         fluid(quality: 90) {
//           ...GatsbyImageSharpFluid
//         }
//       }
//     }
//   }
// `

const Vitay = () => {
    // const data = useStaticQuery(query)
    const lte = <>&#x2264;</>
    const lt = <>&#x3C;</>
    const gt = <>&#x3E;</>

  return (
    <Layout>
      <SEO title="ORLEN | Pricing" />
      <Sublinks />

      <section className="sub-visual sub-visual-instrukcja">
        <div className="container">

            <div className="row mb-3">
            <div className="col-lg-12 mb-3">
                        <h3 className="title text-center mb-2">"Winter Break with ORLEN Charge – Charging for 25% less"<br/>
                        - Promotion period from 01.02 to 28.02.2025</h3>
                        </div>
                          <div className="col-lg-8">
                            <table className={cennikStyles.cennik}>
                              <thead>
                                <tr  className={cennikStyles.ramka}>
                                  <th>Connector</th>
                                  <th className="text-center">Charging fee</th>
                                  <th className="text-center">Discount in days<br/>from 01.02 to 28.02.2025</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className={cennikStyles.typzlacza}>AC</td>
                                  <td className={cennikStyles.cena}>
                                    1,95 <span>PLN/kWh</span>
                                  </td>
                                  <td className={cennikStyles.cena}>
                                    1,46 <span>PLN/kWh</span>
                                  </td>
                                </tr>
                                <tr className={cennikStyles.ramka}>
                                    <td colspan="3" className={cennikStyles.znizkainfo}>Lowest price during the last 30 days before the discount <span className={cennikStyles.red}>1,95</span> PLN/kWh</td>
                                </tr>
                                <tr>
                                  <td className={cennikStyles.typzlacza}>
                                    DC <span>{lte} 50kW</span>
                                  </td>
                                  <td className={cennikStyles.cena}>
                                    2,69 <span>PLN/kWh</span>
                                  </td>
                                  <td className={cennikStyles.cena}>
                                    2,02 <span>PLN/kWh</span>
                                  </td>
                                </tr>
                                <tr className={cennikStyles.ramka}>
                                    <td colspan="3" className={cennikStyles.znizkainfo}>Lowest price during the last 30 days before the discount <span className={cennikStyles.red}>2,69</span> PLN/kWh</td>
                                </tr>
                                <tr>
                                  <td className={cennikStyles.typzlacza}>
                                    DC <span>50kW {lt} x {lte} 125kW</span>
                                  </td>
                                  <td className={cennikStyles.cena}>
                                    2,89 <span>PLN/kWh</span>
                                  </td>
                                  <td className={cennikStyles.cena}>
                                    2,17 <span>PLN/kWh</span>
                                  </td>
                                </tr>
                                <tr className={cennikStyles.ramka}>
                                    <td colspan="3" className={cennikStyles.znizkainfo}>Lowest price during the last 30 days before the discount <span className={cennikStyles.red}>2,89</span> PLN/kWh</td>
                                </tr>
                                <tr>
                                  <td className={cennikStyles.typzlacza}>
                                    DC <span>{gt}125kW</span>
                                  </td>
                                  <td className={cennikStyles.cena}>
                                    3,19 <span>PLN/kWh</span>
                                  </td>
                                  <td className={cennikStyles.cena}>
                                    2,39 <span>PLN/kWh</span>
                                  </td>
                                </tr>
                                <tr className={cennikStyles.ramka}>
                                    <td colspan="3" className={cennikStyles.znizkainfo}>Lowest price during the last 30 days before the discount <span className={cennikStyles.red}>3,19</span> PLN/kWh</td>
                                </tr>
                              </tbody>
                            </table>

                            <div className={`mt-3 p-3 ${cennikStyles.postoj}`}>
                              <strong className="--mb-3">
                                Parking fee PLN 0,30/min<br/>
                              </strong>
                              <p className={cennikStyles.znizkainfo}>Lowest price during the last 30 days before the discount <span className={cennikStyles.red}>0,40</span> PLN/min</p>
                              <div className="row justify-content-center align-items-start">
                                <div className="col-md-6 mb-3 mb-md-0">
                                  <div className={cennikStyles.zegar}>
                                    <div className="flex-shrink-0">
                                      <img src={Min60} alt="" className="img-fluid" />
                                    </div>
                                    <div className="pl-3">
                                      DC <span>after 60 min</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className={cennikStyles.zegar}>
                                    <div className="flex-shrink-0">
                                      <img src={Min600} alt="" className="img-fluid" />
                                    </div>
                                    <div className="pl-3">
                                      AC <span>after 720 min</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={`row px-3 pt-3 ${cennikStyles.fontSmall}`}>
                                Parking fees apply 60
                                minutes after start of charging on the DC connectors and 720
                                minutes on the AC connectors.
                              </div>

                            </div>

                          </div>

                          <div className="col-lg-4">
                          <div className={`d-flex flex-column ${cennikStyles.important}`}>
                              <strong>Important note</strong>
                              <ul>
                                <li>Check out our pricing</li>
                                <li>
                                  Make sure you are using the latest version of the ORLEN
                                  Charge app
                                </li>
                                <li>
                                  Check the availability of a charging station in the ORLEN
                                  Charge app
                                </li>
                                <li>
                                  When done charging, free up the space for other drivers
                                </li>
                              </ul>
                              <p className="mt-auto">
                                The total cost of a charging session is the sum of a PLN/kWh
                                charging fee and a PLN/min parking fee applied after the initial
                                time limit has been exceeded.
                              </p>
                            </div>
                          </div>
                        </div>


        </div>
        <Infolinia customStyle="infolinia-black d-none d-md-flex js-infolinia" />
      </section>


    </Layout>
  )
}
export default Vitay



